import { useMutation } from "@/core/api/graphql/composables";
import { UpdateCustomerOrderWantsProformaInvoiceDocument } from "@/core/api/graphql/types";

export function useUpdateCustomerOrderWantsProformaInvoiceMutation() {
  return useMutation(UpdateCustomerOrderWantsProformaInvoiceDocument);
}
